module.exports = __webpack_public_path__ + "static/crab_folk-b55568b1fbd9c38815e49abb446d6008.jpeg";